import { COLOR_PICKER_LIST_CONFIG } from '@/components/ColorOrEmojiPicker/consts';
import { IconSettings as IconSettingsComp } from '@/components/IconSettings';
import { IconSettings, IconTypeEnum, StatusCategoryEnum } from '@/types/schema';

import STATUS_ICON_MAP from '../statusIconMap';

const DEFAULT_ICON = {
  value: COLOR_PICKER_LIST_CONFIG[0].color,
  type: IconTypeEnum.Color,
};

function getTaskStatusIcon({
  className,
  category,
  icon,
  size = 20,
  progress,
}: {
  className?: string;
  category: StatusCategoryEnum;
  icon?: IconSettings | null;
  size?: number;
  progress?: number | null;
}) {
  const Icon = STATUS_ICON_MAP[category];
  const resolvedIcon = icon ? icon : DEFAULT_ICON;

  return (
    <IconSettingsComp
      Icon={Icon}
      className={className}
      iconSettings={resolvedIcon}
      progress={progress}
      size={size}
    />
  );
}

export default getTaskStatusIcon;
